import React, { useContext, useState } from 'react'
import Layout from 'shared/layouts/Main'
import { roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import { ReactReduxContext } from 'react-redux'
import LayoutSwitcher from 'components/LayoutSwitcher'
import HeaderFilterRoleSelect from 'containers/HeaderFilterRoleSelect'

const SupportForm: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(false)
  const [filterRole, setCurrentFilterRole] = useState<{} | null>({})
  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})
  const { store } = useContext(ReactReduxContext)

  return (
    <>
      <Layout
        footerContent={<Footer />}
        brandContent={getBrandContent()}
        showOverlay={showOverlay}
        showCardHeader={true}
        headerInsert={
          <>
            <HeaderFilterRoleSelect
              setShowOverlay={setShowOverlay}
              handleFilterRoleChanged={(filterRole) => setCurrentFilterRole(filterRole)}
            />
          </>
        }
        menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
      >
        <div className='d-flex justify-content-center'>
          <iframe
            title='Support Form'
            className='text-center'
            width={650}
            height={550}
            src='../support.html'
          ></iframe>
        </div>
      </Layout>
    </>
  )
}

export default SupportForm
